<template>
  <div>
    <span class="mr-10 font_small" style="width:175px;display:inline-block">通过课程名搜索排课信息：</span>
    <el-select
        v-model="value"
        filterable
        remote
        reserve-keyword
        placeholder="请搜索"
        :remote-method="remoteMethod"
        @change="onValSelect"
        :loading="loading">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.title"
          :value="item.id">
        </el-option>
    </el-select>
  </div>
</template>

<script>

import {
  optionsStatApi,
} from "@/api/module/scheduling/scheduling";


export default {

  name : 'SchedulingSelect',

  data(){
    return {
      datas : [],
      value : "",
      selectItem: {},
      loading : false,
      options : []
    }
  },
  methods:{
    remoteMethod(query){
        if(query){
          optionsStatApi(query)
              .then((r)=>{
                this.options = r;               
              })
        }
    },

    onValSelect(val){
      console.log("onValSelect",val)

      for(let i = 0; i < this.options.length;i++){
        if(this.options[i].id == val){
          this.selectItem = this.options[i];
          console.log("find item",this.options[i])
        }
      }

      this.$emit("onValueChanged",val,this.selectItem);
      

    }
  },

  watch:{
    value(){




    }
  },

  mounted(){

  }
  
}
</script>

<style scoped>
.title {
  font-size: 13px;
  color: #000000;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>